import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Esta es una **Lectura sobre posible infidelidad** de 10 cartas. Investigá la inquietud del consultante con honestidad en ambos sentidos: las cartas pueden mostrar involucramiento / tercera persona, o pueden mostrar que NO lo hay (miedo, proyección, distancia de pareja, amistad/laboral sin romance). Leé lo que las cartas sostienen, ni el sesgo del miedo ni el de “tranquilizar a toda costa”.

Si el consultante menciona el nombre o el rol de una persona concreta, activá el modo confirmación: interpretá las posiciones de terceros **solo** respecto a esa persona. No inventes otras terceras personas salvo que las cartas lo indiquen con mucha fuerza.

Hay dos modos de lectura:
- **Modo abierto** (sin nombre concreto): describí una posible tercera persona solo si las cartas lo sostienen. Si no, podés concluir que no aparece una energía de tercero relevante.
- **Modo confirmación / específico** (con nombre o rol concreto): interpretá esas posiciones respecto a esa persona. Podés concluir atracción, amistad, nada, o involucramiento según las cartas.

Equilibrio obligatorio:
- Si las cartas muestran involucramiento, atracción sexual/romántica, secreto o traición: **decilo con claridad, sin suavizar ni endulzar**. No lo disfraces de “solo amistad” o “solo distancia” si eso contradice las cartas.
- Si las cartas NO lo sostienen: **decilo también con claridad**. No inventes un romance oculto ni dramatices amistad, trabajo o frialdad de pareja como infidelidad.
- Si el panorama es mixto o dudoso: decí el matiz (qué se ve y qué no), sin alarmismo gratuito y sin minimizar.

Quiero que interpretes esta tirada para ${data.consultante.name}${
        data.consultante.zodiac ? ` de signo ${data.consultante.zodiac}` : ''
    }${
        data.consulta.length > 0
            ? `, que realiza la siguiente consulta: ${data.consulta}`
            : ''
    }.

Las primeras 8 cartas son las posiciones principales:
1. **Energía actual de la relación** (${cardLabel(cards[0])}): contexto real del vínculo de pareja.
2. **Lo que el consultante no está viendo** (${cardLabel(cards[1])}): sombra / proyección / ceguera propia (puede ser miedo u ocultamiento; lo definen las cartas).
3. **Energía entre la pareja y esa persona** (${cardLabel(cards[2])}): el vínculo real que existe **o no** entre ellos dos.
4. **Naturaleza de esa conexión** (${cardLabel(cards[3])}): ¿atracción, amistad, apoyo emocional, sexual, interés, o nada?
5. **Nivel de involucramiento** (${cardLabel(cards[4])}): qué tan profunda o superficial es la cosa (incluye "nulo / inexistente").
6. **Lo que necesita ser aclarado** (${cardLabel(cards[5])}): la verdad que está pidiendo salir.
7. **Consejo desde la claridad** (${cardLabel(cards[6])}): qué hacer con esta información.
8. **Posible desarrollo** (${cardLabel(cards[7])}): cómo puede evolucionar la situación.

Las cartas 9 y 10 son de **clarificación** (${cardLabel(cards[8])} y ${cardLabel(
        cards[9]
    )}): usalas solo si necesitás ampliar o precisar algún punto; no hace falta forzarlas si el relato ya quedó claro.

Hacé un relato fluido nombrando las cartas dentro de la interpretación (sin enumeración fría carta por carta). Sé claro, concreto y cuidadoso: honestidad sin sensacionalismo y sin edulcorar. Dirígete directamente al consultante en segunda persona. Al final, incluí un párrafo de **respuesta directa** a su inquietud (sí / no / matizado, según las cartas) y un **consejo final**.`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
